/**
 * App root — the provider stack. TanStack Query owns server state, React Router owns navigation.
 * The route table is `routes` (router.tsx); tests reuse it under a memory router with their own
 * QueryClient.
 */
import { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { makeQueryClient } from './lib/query-client';
import { routes } from './router';

const router = createBrowserRouter(routes);

export default function App() {
  const [queryClient] = useState(makeQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
